import type { RenderMode } from "@crashx/shared";
import type { ThemeManifest } from "@crashx/theme-schema";

export function isModeImplemented(mode: RenderMode): boolean {
  return mode === "graph" || mode === "plane" || mode === "rocket";
}
export function availableModes(configured: readonly RenderMode[], theme: ThemeManifest | null): RenderMode[] {
  const modes = configured.filter(
    (mode) => isModeImplemented(mode) && (mode === "graph" || Boolean(theme?.modes[mode])),
  );
  return modes.length ? modes : ["graph"];
}
